import type Organization from '../types/Organization';
import type SinatraState from '../types/SinatraState';
import { selectUserOrganizations } from './selectUserOrganizations';

/** Only the user slice is read, so any state carrying it is enough. */
type SinatraUserSlice = Pick<SinatraState, 'user'>;

/**
 * Find the organization in orgs that has a role for the given appName.
 * @param orgs - The organizations to search
 * @param appName - The name of the application to match
 * @returns the matching org, or undefined when orgs is unusable or nothing matches
 */
export function selectOrgByAppName(
  orgs: Organization[] | undefined,
  appName: string,
): Organization | undefined {
  if (!Array.isArray(orgs)) {
    return undefined;
  }
  return orgs.find(org =>
    (org?.roles ?? []).some(role => role?.application === appName),
  );
}

/**
 * Find the organization that matches the given appName for the current user.
 * @param sinatra - The sinatra state
 * @param appName - The name of the application to match
 * @returns the matching org, or undefined when nothing matches or the user's
 * orgs are unavailable
 */
export function selectUserOrgByApp(
  sinatra: SinatraUserSlice,
  appName: string,
): Organization | undefined {
  return selectOrgByAppName(selectUserOrganizations(sinatra?.user), appName);
}

export default selectUserOrgByApp;
